import { ActionTypes } from '../constants/ActionTypes';

export function setUsers(users) {
    return {
        type: ActionTypes.ADD_USER,
        users
    };
};

export function selectUser(users, query) {
    return {
        type: ActionTypes.SELECT_USER,
        users,
        query
    }
}

export function selectUserMap(usersMap) {
    return {
        type: ActionTypes.SELECT_USER_MAP,
        usersMap,
    }
}

export function techLocation(techLocation) {
    return {
        type: ActionTypes.TECH_LOCATION,
        techLocation,
    }
}

export function addUser(users) {
    return {
        type: ActionTypes.ADD_USER,
        users
    }
}

export function createUser(user) {
    return {
        type: ActionTypes.CREATE_USER,
        user: user
    }
}

export function deleteUser(userId,msg) {
    return {
        type: ActionTypes.DELETE_USER,
        msg: msg,
        userId:userId
    }
}

export function getUserId(userId) {
    return {
        type: ActionTypes.GET_USER_ID,
        userId:userId
    }
} 

export function editUser(user,msg) {
    return {
        type: ActionTypes.EDIT_USER,
        user:user,
        msg:msg
    }
}





// WEBPACK FOOTER //
// ./src/actions/users.js